export const paddingTemplate = () => {
  return `<div class="padding-component"></div>`;
};
